import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { tok, tokPx } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const SheetContentTitle = styled(Typography)`
  margin-bottom: ${tokPx('primitives_space_16')};
`

const FieldSection = styled.div`
  background-color: ${tok('semantics_views_tinted_background_color')};
  padding: ${tokPx('primitives_space_12')};
  margin-bottom: ${tokPx('primitives_space_8')};
  border-radius: ${tokPx('primitives_corner_radius_m')};
`

const FieldSectionTitle = styled(Typography)`
  color: ${tok('semantics_content_secondary_color')};
`

const SheetContentStyled = styled(Sheet.Content)`
  color: ${tok('semantics_content_color')};
`

const SheetHeaderStyled = styled(Sheet.Header)`
  color: ${tok('semantics_content_color')};
`

const SectionTitle = styled(Typography)`
  margin-top: ${tokPx('primitives_space_24')};
  margin-bottom: ${tokPx('primitives_space_8')};
`

const SpacedRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${tokPx('primitives_space_12')};
`

const NoShrink = styled(Typography)`
  flex-shrink: 0;
`

export {
  FieldSection,
  FieldSectionTitle,
  NoShrink,
  SectionTitle,
  SheetContentStyled,
  SheetContentTitle,
  SheetHeaderStyled,
  SpacedRow,
}
